'use strict'

console.log('[COM] V 1.0.8');

window.crm = {}
crm.ajax = (function () {
   var _instance = null;
   
   var _proxy = {
      CODE_SUCCESS: 'FWK_SUCCESS',
      CODE_NO_DESTINATION_DEFINED: 'FWK_NO_DESTINATION_DEFINED',
      CODE_CALL_OVERRIDEN: 'FWK_CALL_OVERRIDEN',
      CODE_COMM_ERROR: 'FWK_COMM_ERROR',
      CODE_NOT_CONFIGURED: 'FWK_NOT_CONFIGURED'
   };
   var _busy = false;
   var _url = null; // Destination url
   var _dataproxy = null;
   var _dpenv = 'prod'; // Environment to inform to data proxy (this helps on deciding what environment needs to be authenticated)
   var _interval = null; // Time to wait for deferred requests

   function configureDestination(url) {
      _url = url;
      return this;
   }

   function configureDataProxy(url) {
      _dataproxy = url;
      return this;
   }
   function configureDataProxyEnv(env) {
      _dpenv = env;
      return this;
   }

   function configureDeferredTime(t) {
      if (t <= 1) {
         throw 'Invalid time for interval ' + t;
      }
      if (_interval) {
         clearInterval(_interval);
      }
      _interval = setInterval(_onTick, t * 1000);
   }

   // Lazy loading method
   function getInstance() {
      if (!_instance) {
         _build();
      }
      return _instance;
   }

   function isConfigured() {
      if (_url == null) {
         return false;
      }
      return true;
   }

   function _handleResponse(req, callback, reqId) {
      console.log('[AJX] Handle response for ' + reqId + ', state: ' + req.readyState);
      if (req.readyState == 4) {
         var data = null;
         var text = req.responseText;
         console.log('[AJX] Handle response status: ' + req.status + ', text ' + req.responseText);
         if (text != null) {
            text = text.trim();
         }
         if (text.indexOf('{') == 0) {
            data = JSON.parse(text);
         }
         if (req.status == 200 && data.errorCode == undefined) {
            callback(_proxy.CODE_SUCCESS, data, reqId);
         } else {
            // console.log('-- Obtained ERROR status code: ' + req.status + ' and text "' + req.responseText + '"');
            if (data && data.errorCode) {
               callback(data.errorCode, data.message, reqId);
            } else {
               callback(_proxy.CODE_COMM_ERROR, 'SERVER Status code ' + req.status + ' with message "' + req.responseText + '"', reqId);
            }
         }
      }
   }

   function getCities(cityText, countryISO, provinceText, postCode, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }

      var execute = function () {
         var req = new XMLHttpRequest();
         var url = _url + '/services/apexrest/public/cities?cityFragment=' + cityText;
         if (countryISO) {
            url += '&countryISO=' + countryISO;
         }
         if (provinceText) {
            url += '&province=' + provinceText;
         }
         if (postCode) {
            url += '&postCode=' + postCode;
         }

         req.open('GET', url);
         req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);
         req.send();
      }
      _addRequestDeferred('citiesRQ', callback, execute, reqId);
   }
   function getExtDataSourceInfo(extUrl, params, datasource, fuente, caller, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      var execute = function() {
         var req = new XMLHttpRequest();
         var url = extUrl + '?fuente=' + fuente + '&ds=' + datasource;
         for (var k in params) {
            if (params[k]) {
               url += '&' + k + '=' + encodeURIComponent(params[k]);   
            }
         }
         
         req.open('GET', url);
         req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);
         req.send();
      }
      _addRequestDeferred('dsRQ' + datasource + caller, callback, execute, reqId);
      
   }

   function getDataSourceInfo(params, datasource, fuente, caller, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      var execute = function() {
         var req = new XMLHttpRequest();
         var url = _url + '/services/apexrest/public/gfdatasource?fuente=' + fuente + '&ds=' + datasource;
         for (var k in params) {
            if (params[k]) {
               url += '&' + k + '=' + encodeURIComponent(params[k]);   
            }
         }
         
         req.open('GET', url);
         req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);
         req.send();
      }
      _addRequestDeferred('dsRQ' + datasource + caller, callback, execute, reqId);
      
   }



   function getProvinces(provinceText, country, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }

      var execute = function () {
         var req = new XMLHttpRequest();
         var url = _url + '/services/apexrest/public/provinces?provinceFragment=' + provinceText;
         if (country) {
            url += '&countryISO=' + country;
         }
         req.open('GET', url);
         req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);
         req.send();
      }
      _addRequestDeferred('provincesRQ', callback, execute, reqId);
   }

   function getPostCodes(postcode, country, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      var execute = function () {
         var req = new XMLHttpRequest();
         req.open('GET', _url + '/services/apexrest/public/postalCode/' + postcode + '?country=' + country, true);
         req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);
         req.send();
      }
      _addRequestDeferred('postCodeRQ', callback, execute, reqId);
   }

   function searchAccounts(nameFragment, accType, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      console.log('[AJX] Sending request to ' + nameFragment);
      var execute = function () {
         var req = new XMLHttpRequest();

         req.open('GET', _url + '/services/apexrest/public/accounts/?tipoFuente=' + encodeURIComponent(accType) +
            '&name=' + encodeURIComponent(nameFragment) + '&rnd=' + encodeURIComponent(Math.random()));
         req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);
         req.send();
      }
      _addRequestDeferred('accountRQ', callback, execute, reqId);
   }

   function getDisciplinas(callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      var req = new XMLHttpRequest();
      req.open('GET', _url + '/services/apexrest/public/disciplinas');
      req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);
      req.send();
   }

   function sendFile(name, data, idFuente, compName, endpoint, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      var req = new XMLHttpRequest();
      console.log('[AJX] Sending file: ' + name + ', with data ' + data);
      
      if (_dataproxy == null) {
         req.open('POST', _url + endpoint + '?name=' + name + '&idFuente=' + idFuente + '&compName=' + compName);
      } else {
         req.open('POST', _dataproxy + '?dest=' + encodeURIComponent(endpoint + '?name=' + name + '&idFuente=' + idFuente + '&compName=' + compName) + '&env=' + _dpenv);
      }
      req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);
      
      req.send(data);
   }
   function getData(endpoint, callback, reqId) {
      var req = new XMLHttpRequest();
      req.open('GET', _url + endpoint);
      req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);

      req.send();
   }
   
   function sendData(fuente, data, endpoint, callback, reqId) {
      var method = arguments.length > 5 && arguments[5] ? arguments[5] : 'POST';
      var id = arguments.length > 6 && arguments[6] ? arguments[6] : ''; 

      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      console.log('[AJX] Sending data to: ' + _url + ' + ' + endpoint)
      var req = new XMLHttpRequest();
      // req.open('POST', _url + endpoint);
      if (_dataproxy == null) {
         req.open(method, _url + endpoint + (method=='POST' ? '' : '&id='+id));
      } else {
         req.open(method, _dataproxy + '?dest=' + encodeURI(endpoint) + '&env=' + _dpenv + (method=='POST' ? '' : '&id='+id));
      }
      req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);
      var payload = {
         "idFuente": fuente,
         "submit": data
      };
      
      req.send(JSON.stringify(payload));
   }

   function addPersona(fuente, contact, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      var req = new XMLHttpRequest();
      var endpoint = '/services/apexrest/public/persona/';
      if (_dataproxy == null) {
         req.open('POST', _url + endpoint);
      } else {
         req.open('POST', _dataproxy + '?dest=' + encodeURIComponent(endpoint) + '&env=' + _dpenv);
      }
      req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);

      var data = {
         "idFuente": fuente,
         "submit": contact
      };
      req.send(JSON.stringify(data));
   }

   function getInvestigador(contactId, opportunityId, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      var req = new XMLHttpRequest();
      req.open('GET', _url + '/services/apexrest/public/investigadores/?contactId=' + contactId + '&oppId=' + opportunityId + '');
      req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);

      // TODO: Send request
      req.send();

   }

   function getGenForm(fuente, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }

      var req = new XMLHttpRequest();
      req.open('GET', _url + '/services/apexrest/public/genform?fuente=' + fuente);
      req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);


      req.send();
   }
   function updatePersona(fuente, contactId, contact, callback, reqId) {
      if (!isConfigured()) {
         callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
         return;
      }
      var req = new XMLHttpRequest();
      req.open('PUT', _url + '/services/apexrest/public/persona/' + contactId);
      req.onreadystatechange = _handleResponse.bind(this, req, callback, reqId);

      var data = {
         "idFuente": fuente,
         "submit": contact
      };
      req.send(JSON.stringify(data));
   }

  function getProfileCenter(contactId,comExtId,callback,reqId){
    if (!isConfigured()) {
        callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
        return;
    }
    var req = new XMLHttpRequest();
    req.open('GET', _url + '/services/apexrest/public/profile_center/?contactId=' + encodeURIComponent(contactId) + '&idProfileCenter=' + encodeURIComponent(comExtId));
    req.onreadystatechange =  _handleResponse.bind(this, req, callback, reqId);

    // TODO: Send request
    //var data = {"contactId":contactId,"idProfileCenter":comExtId,'email':email};
    req.send();
  }

  function updateProfileCenter(fuente, contactId, contact,logsConsentimiento,comExtId, callback, reqId) {
    if (!isConfigured()) {
      callback(_proxy.CODE_NOT_CONFIGURED, 'Ajax library not configured', reqId);
      return;
    }
    var req = new XMLHttpRequest();
    var endpoint = '/services/apexrest/public/profile_center/';
    console.log('[AJX] Proxy: ' + _dataproxy)
    if (_dataproxy == null) {
      req.open('POST', _url + endpoint);
   } else {
      req.open('POST', _dataproxy + '?dest=' + encodeURIComponent(endpoint) + '&env=' + _dpenv);
   }
    // req.open('POST', _url + '/services/apexrest/public/profile_center/');
    req.onreadystatechange =  _handleResponse.bind(this, req, callback, reqId);

    var data = {"idFuente":fuente,"contactId":contactId,"submit":contact, "logConsentimiento":logsConsentimiento, "idProfileCenter":comExtId};
    req.send(JSON.stringify(data));
  }

   var requestsMap = {}

   function _DeferredRequest(callback, executeFnc, requestId) {
      this.callback = callback;
      this.executeFnc = executeFnc;
      this.requestId = requestId;
   }

   function _addRequestDeferred(typeId, callback, executeFnc, requestId) {
      if (requestsMap[typeId]) {
         requestsMap[typeId].callback(_proxy.CODE_CALL_OVERRIDEN, 'Call has been overriden by a new one', requestsMap[typeId].requestId);
      }
      requestsMap[typeId] = new _DeferredRequest(callback, executeFnc, requestId);
   }

   function _onTick() {

      if (_busy) {
         console.log('[AJX] Cycle with busy flag. Skipping')
      }
      // console.log('[AJX] Tick tack on deferred requests');
      _busy = true;
      for (var k in requestsMap) {
         console.log('[AJX] Found request to send with key ' + k);
         requestsMap[k].executeFnc();
         delete requestsMap[k]
      }
      _busy = false;
   }

   // Constructor
   function _build() {
      _instance = {};

      // Set instance public methods
      _instance.configureDestination = configureDestination;
      _instance.configureDataProxy = configureDataProxy;
      _instance.configureDataProxyEnv = configureDataProxyEnv;
      _instance.configureDeferredTime = configureDeferredTime;

      _instance.addPersona = addPersona;
      _instance.sendData = sendData;
      _instance.sendFile = sendFile;
      _instance.getPostCodes = getPostCodes;
      _instance.getCities = getCities;
      _instance.getProvinces = getProvinces;
      _instance.getDisciplinas = getDisciplinas;
      _instance.updatePersona = updatePersona;
      _instance.getInvestigador = getInvestigador;
      _instance.searchAccounts = searchAccounts;
      _instance.getProfileCenter = getProfileCenter;
    _instance.updateProfileCenter = updateProfileCenter;
    _instance.getGenForm = getGenForm;
      _instance.getDataSourceInfo = getDataSourceInfo;
      _instance.getExtDataSourceInfo = getExtDataSourceInfo;
      _instance.getData = getData;

      _interval = setInterval(_onTick, 1000);

      console.log('[AJX] Ajax singleton built');
   }
   _proxy.getInstance = getInstance;
   return _proxy;
})();
